import { render, staticRenderFns } from "./PuzleModal.vue?vue&type=template&id=68f9fa04&scoped=true&"
import script from "./PuzleModal.vue?vue&type=script&lang=js&"
export * from "./PuzleModal.vue?vue&type=script&lang=js&"
import style0 from "./PuzleModal.vue?vue&type=style&index=0&id=68f9fa04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f9fa04",
  null
  
)

export default component.exports